__turbopack_context__.v({
  "card": "experience-destinations-slider-module__7U3_0W__card",
  "content": "experience-destinations-slider-module__7U3_0W__content",
  "controls": "experience-destinations-slider-module__7U3_0W__controls",
  "count": "experience-destinations-slider-module__7U3_0W__count",
  "deck": "experience-destinations-slider-module__7U3_0W__deck",
  "eyebrow": "experience-destinations-slider-module__7U3_0W__eyebrow",
  "flag": "experience-destinations-slider-module__7U3_0W__flag",
  "flagImg": "experience-destinations-slider-module__7U3_0W__flagImg",
  "frame": "experience-destinations-slider-module__7U3_0W__frame",
  "go": "experience-destinations-slider-module__7U3_0W__go",
  "head": "experience-destinations-slider-module__7U3_0W__head",
  "img": "experience-destinations-slider-module__7U3_0W__img",
  "name": "experience-destinations-slider-module__7U3_0W__name",
  "nameRow": "experience-destinations-slider-module__7U3_0W__nameRow",
  "nav": "experience-destinations-slider-module__7U3_0W__nav",
  "next": "experience-destinations-slider-module__7U3_0W__next",
  "prev": "experience-destinations-slider-module__7U3_0W__prev",
  "region": "experience-destinations-slider-module__7U3_0W__region",
  "rule": "experience-destinations-slider-module__7U3_0W__rule",
  "scrim": "experience-destinations-slider-module__7U3_0W__scrim",
  "section": "experience-destinations-slider-module__7U3_0W__section",
  "slide": "experience-destinations-slider-module__7U3_0W__slide",
  "slider": "experience-destinations-slider-module__7U3_0W__slider",
  "title": "experience-destinations-slider-module__7U3_0W__title",
});
